import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDirectExpenseBalance,
  fetchDirectExpenseAccountsBySearch,
} from "./DirectExpenseBalanceThunk";

const initialState = {
  list: [],
  loading: false,
  directAccounts: [],
  directAccountLoading: false,
  balanceTotal: 0,
  filters: {
    filterType: "All", // All | Wise
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const directExpenseBalanceSlice = createSlice({
  name: "directExpenseBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDirectExpenseBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDirectExpenseBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.expenses;
        state.balanceTotal = action.payload.total_balance;
      })
      .addCase(fetchDirectExpenseBalance.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchDirectExpenseAccountsBySearch.pending, (state) => {
        state.directAccountLoading = true;
      })
      .addCase(
        fetchDirectExpenseAccountsBySearch.fulfilled,
        (state, action) => {
          state.directAccountLoading = false;
          state.directAccounts = action.payload;
        }
      )
      .addCase(fetchDirectExpenseAccountsBySearch.rejected, (state) => {
        state.directAccountLoading = false;
        state.directAccounts = [];
      });
  },
});

export const { setFilters } = directExpenseBalanceSlice.actions;
export default directExpenseBalanceSlice.reducer;
